import { render, staticRenderFns } from "./SettingsMerge.vue?vue&type=template&id=7a4005db&scoped=true&"
import script from "./SettingsMerge.vue?vue&type=script&lang=ts&"
export * from "./SettingsMerge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4005db",
  null
  
)

export default component.exports